<template>
  <pt-video-manage-table class="pt-video-manage-table__withData" @getTableData="getTableData" :tableData="tableData" :tableLabel="tableLabel" :totalNumber="totalNumber"
  ref="tableIndex" :isOutside="isOutside">
  <slot/>
  </pt-video-manage-table>
</template>

<script>
import PtVideoManageTable from './index'
export default {
  name: 'pt-video-manage-table__withData',
  components: {
    'pt-video-manage-table': PtVideoManageTable
  },
  props: {
    tableLabel: {
      type: Array,
      default: function () {
        return []
      }
    },
    pageSize: {
      type: Number,
      default: 10
    },
    paramsData: {
      type: Object,
      default: function () {
        return {}
      }
    },
    isFromRouter: {
      type: Boolean,
      default: false
    },
    isSearch: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      tableData: [],
      totalNumber: 0,
      isOutside: false
    }
  },
  computed: {
    page () {
      return this.$refs.tableIndex.page
    }
  },
  watch: {
    paramsData: {
      handler: function (val) {
        if (!this.isFromRouter) {
        //   this.getTableData(0)
          this.$refs.tableIndex.resetPage()
        } else {
          this.isOutside = true
          this.getTableData(this.page)
        }
      },
      deep: true
    }
  },
  methods: {
    getTableData (page, next) {
      let data = {
        example: {
          type: 'VIDEO'
        },
        pageable: {
          page: page,
          size: this.pageSize
        },
        searchKey: this.paramsData ? this.paramsData.searchKey : null
      }
      if (this.paramsData && this.paramsData.type) {
        data.example = {
          type: this.paramsData.type
        }
      }
      if (this.paramsData && this.paramsData.publishTime) {
        this.$delete(this.paramsData.publishTime, 'index')
        data = {
          ...data,
          ...this.paramsData.publishTime
        }
      }
      let api = this.isSearch ? 'searchPoster' : 'getPosterList'
      this.$store.dispatch(api, data).then(res => {
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        console.log(this.tableData)
        if (next) {
          next(res.data)
        }
      }).catch(err => {
        this.$refs.tableIndex.showReTry()
        this.$message.error(err || '获取海报列表失败')
      })
    },
    load () {
      // this.$nextTick(_ => {
      this.$refs.tableIndex.load()
      // })
    }
  }
}
</script>
